import { html, LitElement } from 'lit';
import { geoProjects, utils } from '../modules/GeoProjects.js';
import { icons } from '../utils/SVGIcons.js'

export default class SWLRIGeoProjectsList extends LitElement {
    static get properties(){
        return {
            _projectsList: {state:true},
            _toggledFiles: {state:true},
            _error: {state: true}
        }
    }

    constructor(){
        super();
        this._projectsList = [];
        this._totalPageNumber = 0;
        this._error = null;
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback(){
        super.connectedCallback();
        window.addEventListener("swlri-geo-projects-list-changed", this._updateProjectList.bind(this));

        geoProjects.getProjectsList();
    }

    _getHeaderCount(){
        let h = '';
        let count = geoProjects._currentTotalProjects;
        h = count + " Project"+(count == 0 || count > 1 ? 's' : '') +" found";
        
        return h;
    }

    _toggleFileInfo(e){
        e.preventDefault();
        let ind = e.currentTarget?.getAttribute("file-ind");
        if(ind) {
            this._toggledFiles[+ind] = !this._toggledFiles[+ind]
        }
        this._toggledFiles = {...this._toggledFiles};

    }


    _formatColOutput(record, type, icon = true, full = false){
        let rec = record;
        if(type == 'created_at'){
            let date = record;
            try{
                rec = utils.joinDate(new Date(date))
            } catch(e){
                console.log(e)
                rec = date;
            }
        }
        else if(type == 'abstract' && !full){
            if(rec !== null && rec.length > 500) {
                rec = rec.substr(0,500) + '...';
                
            }
        }
        return utils.unsafeOutput(rec);
    }

    _openProject(e){
        e.preventDefault();
        e.stopPropagation();
        let projectpath = e.currentTarget.getAttribute("project-path")
        if(projectpath ){
            window.open(projectpath, "_blank");
        }

    }

    _toggleFilter(e){
        e.preventDefault()
        geoProjects.filterPanelOpened = true;
    }

    render(){
        return html`
            ${this._error ? html`<div>${this._error}</div>` :html`
                <div class ='swlri-geo-projects-toggle-mobile-filter'>
                    <span @click=${this._toggleFilter} class='swlri-file-manager-browse-text-filter-icon'>${icons.searchIcon}</span> <h4>Filters</h4>
                </div> 
                <h4 class='swlri-geo-projects-results-header'>
                    <span class='swlri-geo-projects-results-header-count'>${this._getHeaderCount()}</span>
                </h4>
                <div class="swlri-geo-projects-results-container">
                    ${this._projectsList.map((project,ind)=>{
                        return html`
                            <div class="swlri-geo-projects-result-card">
                                <div class='swlri-geo-projects-thumb-container'>
                                    <img src='${project.image}'/>
                                </div>
                                <div class='swlri-geo-projects-info-container'>
                                    <span class='swlri-geo-projects-info-title' @click=${this._openProject} project-path="${project.full_url}">${utils.unsafeOutput(project.title)}</span>
                                    <span class='swlri-geo-projects-info-repository'><span class='swlri-geo-projects-info-icon'>${icons.geographicIcon}</span><span>${utils.unsafeOutput(project.repository)}</span></span>
                                    <span class='swlri-geo-projects-info-note'>${this._formatColOutput(project.abstract, 'abstract')}</span>
                                </div>
                            </div>
                        `
                    })}
                </div>
                <div class='swlri-geo-projects-results-pagination'>
                    ${this._projectsList.length ? html`
                        <span class='swlri-geo-projects-results-pagination-pages'><span class="swlri-geo-projects-pagination-icon" page='prev' @click=${this._changePage}>${icons.chevLeft}</span><span class="swlri-file-manager-browse-pagination-text">${this._getFooterNavigation()}</span><span page='next' class="swlri-geo-projects-pagination-icon" @click=${this._changePage}>${icons.chevRight}</span></span>
                    ` : ''}
                </div>`
            }
        `;
    }

    _changePage(e){
        let page = e.currentTarget?.getAttribute("page");
        if(page != 'next' && page != 'prev') return;

        let forward = page == 'next';
        let newPage = geoProjects.currentPage;
        if(forward && geoProjects.currentPage + 1 <=  this._totalPageNumber){
            newPage = geoProjects.currentPage + 1;
        }
        else if (!forward && geoProjects.currentPage - 1 > 0){
            newPage = geoProjects.currentPage - 1
        } else return;

        geoProjects.currentPage = newPage;

    }
    _getFooterNavigation(){
        return 'Page '+geoProjects.currentPage + ' of ' +  this._totalPageNumber;
    }

    _updateProjectList(){
        const limit = 5;
        this._totalPageNumber = Math.ceil(geoProjects._currentTotalProjects/limit);
        //this._toggledFiles = {...toggledFiles};
        this._projectsList = [...geoProjects._projectsList];
        this._error = geoProjects.projectsError;
    }
}